import React, { Component } from 'react';
import Card, { CardTitle, CardContent } from './Card';
import Tabs, { TabsProps } from './Tabs';

export interface Tag
{
	title: string
	href?: string
}

export interface NewsItemProps
{
	title: string
	href: string
	date: string
	summary?: string
	tags?: Tag[]
}

export interface NewsCategory
{
	title: string
	newsItems: NewsItemProps[]
	moreLink: string
}

export interface NewsProps
{
	news: NewsCategory[]
}

export default class News extends Component<NewsProps>
{
	protected tabContent = (newsItems: NewsItemProps[], moreLink: string) =>
	{
		return (
			<React.Fragment>
				{newsItems.map( (item, i) => {
					return (
						<React.Fragment key={i}>
							<NewsItem {...item} />
						</React.Fragment>
					);
				})}
				<p className="margin-bottom-0 margin-left-20" data-testid="newsContent"><a href={moreLink}>More...</a></p>
				<hr />
			</React.Fragment>
		);
	};

	render()
	{
		let newsTabsProps: TabsProps = {
			tabs: []
		}

		this.props.news.map(item => {
			newsTabsProps.tabs.push({
				label: item.title,
				content: this.tabContent(item.newsItems, item.moreLink)
			});
		});

		return (
			<Tabs {...newsTabsProps} />
		);
	}
}

export class NewsItem extends Component<NewsItemProps>
{
	render()
	{
		return(
			<Card extraClassnames="ajb-inset-squish--m">
				<CardContent>
					<CardTitle tag="p" size="s">
						<a href={this.props.href}>
							<b>{this.props.title}</b>
						</a>
					</CardTitle>
					{this.props.summary !== undefined &&
					<p>{this.props.summary}</p>
					}
					<p>
						<small>
							{this.props.tags !== undefined && this.props.tags.length > 0 &&
								this.props.tags.map( (item, i) => {
									if ( item.href !== undefined ) {
										return (
											<React.Fragment key={i}><i className="fa fa-newspaper-o h7" aria-hidden="true"></i> <a href={item.href}>{item.title}</a> | </React.Fragment>
										);
									}
									else {
										return <React.Fragment key={i}>{item.title} | </React.Fragment>;
									}
								})
							}
							<span className="light-text">{this.props.date}</span>
						</small>
					</p>
				</CardContent>
				<hr />
			</Card>
		);
	}
}